import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import { TdLoadingService, TdDialogService, } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { PlanActuacionService, MasterService, LoginService, } from '../../../../../services/';

import { PlanActuacion } from '../../../../../models';

@Component({
  selector: 'qs-planactuaciondetalle',
  styleUrls: ['./planActuaciondetalle.component.scss'],
  templateUrl: './planActuaciondetalle.component.html',
  viewProviders: [PlanActuacionService, MasterService, ],
})

export class PlanActuacionDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;

  private idPaciente: string;
  private visita: string;
  private cias: string;
  private colegiado: string;
  private accion: string;

  private planActuacion: PlanActuacion;
  private oldPlanActuacion: PlanActuacion;

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _planActuacionService: PlanActuacionService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.colegiado = this._loginService.colegiado;
    this.cias = this._loginService.cias;
    this.visita = this._loginService.consulta.visita;
    this.planActuacion = new PlanActuacion();
    this.oldPlanActuacion = new PlanActuacion();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.planActuacion = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {
    let fecha: Date = new Date();
    let message: string = '';
    let error: string = '';
    let messages: string[] = [
      'Plan de Actuacion Añadido correctamente.', 'Error añadiendo Plan de Actuacion.',
      'Plan de Actuacion Actualizado correctamente.', 'Error actualizando Plan de Actuacion.',
      'Plan de Actuacion Borrado correctamente.', 'Error borrando Plan de Actuacion', ];
    let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    switch (this.mode) {
      case 'edit':
        this.accion = 'M';
        message = messages[2];
        error = message[3];
        break;
      case 'add':
        this.accion = 'I';
        message = messages[0];
        error = messages[1];
        break;
      case 'del':
        this.accion = 'B';
        message = messages[4];
        error = messages[5];
        break;
      default: break;
    }

    if (form.valid) {
      this._loadingService.register();
      let params: any = {
        iIdPlanActuacion: this.accion !== 'I' ? this.planActuacion.idPlan : '',
        iNumExpediente: this.idPaciente,
        iFecha: fecha,
        iNumVisita: this.visita,
        iDniMed: this._loginService.profesional.Dni,
        iLinea: 0,
        iTipo: 'G',
        iCias: this.cias,
        iTexto: this.planActuacion.texto,
        iHora: hora,
        iAccion: this.accion,
      };
      this._planActuacionService.guardarPlanActuacion(params).subscribe((res: any) => {
        if (res) {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
          this._router.navigate(['/main/consulta/' + this.idPaciente + '/hojadeseguimiento', { outlets: { hojadeseguimiento: ['plan'] } }]);
        } else {
          this._loginService.mostrarMensaje(message, 'OK', 6000);
          this._loadingService.resolve();
        }
      }, (resError: Error) => {
        this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
        this._loadingService.resolve();
      });
    }
  }

  /*
  canDeactivate(): Promise<boolean> | boolean {
    if ((this.oldPlanActuacion.principioActivo == this.planActuacion.principioActivo) &&
      (this.oldPlanActuacion.fecha.getDate() == this.planActuacion.fecha.getDate()) &&
      (this.oldPlanActuacion.estado == this.planActuacion.estado) &&
      (this.oldPlanActuacion.tipo == this.planActuacion.tipo)) {
      return true;
    } else {
      if (this.mode != 'save') {
        return new Promise((resolve) => {
          this._dialogService.openConfirm({
            message: 'Si pulsa aceptar, se perderán los datos introducidos.',
            title: '¿Desea abandonar el alta de planActuacion?',
            acceptButton: 'Aceptar',
            cancelButton: 'Cancelar'
          }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return true;
      }
    }
  }*/

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/planactuacion/planactuaciondetalle/planactuaciondetalle.component.ts